import { getNumbersFromStr } from '../text/get-numbers-from-str';

import type { TMeta, TIsErrorFn } from './models';

export const fullLengthValueConfig = {
    phone: 11,
    birthday: 8,
};

export const isError: TIsErrorFn = ({
    active,
    dirtySinceLastSubmit,
    error,
    submitError,
    touched,
}: TMeta) => {
    if (active) return false;
    if (error) return touched;
    if (submitError) return !dirtySinceLastSubmit;

    return false;
};

const createIsError =
    (fullLengthValue: number): TIsErrorFn =>
    ({ active, dirtySinceLastSubmit, error, submitError, touched }: TMeta, value?: string) => {
        if (getNumbersFromStr(value).length === fullLengthValue && error) {
            return active || touched;
        }
        if (error) return touched;
        if (submitError) return !dirtySinceLastSubmit;

        return false;
    };

export const isPhoneError = createIsError(fullLengthValueConfig.phone);
export const isBirthdayError = createIsError(fullLengthValueConfig.birthday);
